<template>
  <div class="AlbumListCard" v-viewer="{ url: 'large',loading: true,title: 'alt',loop: true,navbar:false,title:false}">
      <template v-if="imagelist == []">
       <div class="null">
          <img src="@/common/images/leveing/video/null.png" alt="直播空">
          <p>暂无内容</p>
        </div>
      </template>
      <template v-else>
        <div class="video-item"  v-for="(item, index) in imagelist" :key="index">
          <img class="video-img" v-lazy="item.coveratturl" :alt="item.name">
        </div>
      </template>
  </div>
  <!-- end 相册模块 -->
</template>

<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    url: 'data-source',
    loading: true,
    title: 'alt',
    loop: true
  }
})
export default {
  name: 'AlbumListCard',
  props: ['item'],
  data () {
    return {
      imagelist: []
    }
  },
  mounted () {
    this.imagelist = this.item.imagelist
  },
  methods: {},
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.AlbumListCard {
    overflow: hidden;
    margin-left: -26px;
    .null {
      margin-top: 40px;
      img {
        display: block;
        margin: auto;
        margin-top: 30px;
        width: 127px;
        height: 120px;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
        color: #999;
      }
    }
    .video-item {
        float: left;
        margin-bottom: 27px;
        margin-left: 26px;
        position: relative;
        width:256px;
        height:143px;
        cursor: pointer;

        .video-img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            background: #ccc;
        }
    }
}
</style>